import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'

export const SET_ROUND_DATA = 'institute/SET_ROUND_DATA'
export const UPDATE_ROUND_DATA = 'institute/UPDATE_ROUND_DATA'
export const SET_PREVIEW_DATA = 'institute/SET_PREVIEW_DATA'
export const GET_JOB_ROLE_PREVIEW_DATA = 'institute/GET_JOB_ROLE_PREVIEW_DATA'
export const setRoundData = data => {
  return {
    type: SET_ROUND_DATA,
    data,
  }
}
export const updateRoundData = data => {
  return {
    type: UPDATE_ROUND_DATA,
    data,
  }
}
export const setPreviewData = data => {
  return {
    type: SET_PREVIEW_DATA,
    data,
  }
}

export const addNewRound = id => async (dispatch, getState) => {
  try {
    const result = await corporateRequest.get(
      `corporates/role/${id}/interviewRounds`
    )
    dispatch(setRoundData(result?.data?.data))
    return result
  } catch (error) {
    //console.log(error)
  }
}

export const updateNewRound = (payload, id) => async (dispatch, getState) => {
  try {
    dispatch(updateRoundData(''))
    const result = await corporateRequest.put(
      `corporates/role/${id}/interviewRounds`,
      payload
    )
    dispatch(updateRoundData(result?.data))
    SuccessMessage('New round added successfully')
    return result
  } catch (error) {}
}
export const updateCandidateRoleStatus =
  (payload, instituteCampusId, jobId) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.put(
        `/corporates/instiuteCampus/${instituteCampusId}/jobs/${jobId}/status/update`,
        payload
      )
      SuccessMessage(result?.data?.message)
      return result
    } catch (error) {}
  }

export const bulkUploadForAts =
  (payload, instituteCampusId, jobId) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.post(
        `/corporates/instituteCampus/${instituteCampusId}/job/${jobId}/candidates/status/bulkUpload`,
        payload
      )
      return result
    } catch (error) {
      throw error
    }
  }
export const getPreviewData = student_Id => async (dispatch, getState) => {
  try {
    const res = await studentRequest.get(`/students/${student_Id}`)
    dispatch(setPreviewData(res?.data?.data || {}))
    return res
  } catch (error) {}
}
// The same student can submit a different Tally resume for every role, so the
// resume drawer must ask for the role it was opened from. Without roleId the
// student endpoint returns the shared profile, which is whichever role wrote
// last — that is how Role 1's drawer ended up showing Role 2's education and
// work experience.
export const getPreview =
  (student_Id, roleId) => async (dispatch, getState) => {
    try {
      const res = await studentRequest.get(
        `/students/${student_Id}${roleId ? `?roleId=${encodeURIComponent(roleId)}` : ''}`
      )
      return res?.data?.data
    } catch (error) {}
  }

export const resolveConflict =
  (instituteCampusId, jobId, pageSize, searchBy, roundId) =>
  async (dispatch, getState) => {
    try {
      const search = searchBy !== '' ? `&search=${searchBy}` : ''
      const round = roundId ? `&roundId=${roundId}` : ''
      const result = await corporateRequest.get(
        `/corporates/instituteCampus/${instituteCampusId}/job/${jobId}/conflictCandidates/list?pageLimit=10&pageNo=${pageSize}${search}${round}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getCandidateDegree =
  (instituteCampusId, roleId, index, search, publsihedBy) =>
  async (dispatch, getState) => {
    try {
      let stage = index === null ? '' : `&stageIndex=${index}`
      let forInstitute =
        publsihedBy == 'INSTITUTE'
          ? `&forInstitute=true`
          : `&forInstitute=false`
      let getSearch = `?search=${search || ''}`
      const result = await studentRequest.get(
        `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/filter${getSearch}${stage}${forInstitute}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getCandidateDepart =
  (instituteCampusId, roleId, index, degreeIds, search, publsihedBy) =>
  async (dispatch, getState) => {
    try {
      let stage = index === null ? '' : `&stageIndex=${index}`
      let degreeId = degreeIds?.map(item => item.value).join(',')
      let searchData = `&search=${search || ''}`
      let checkDegree = degreeId?.length ? `&degreeIds=${degreeId}` : ''
      let forInstitute =
        publsihedBy == 'INSTITUTE'
          ? `&forInstitute=true`
          : `&forInstitute=false`
      const result = await studentRequest.get(
        `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/filter?forStream=true${stage}${checkDegree}${searchData}${forInstitute}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }


  export const getCandidateSpecialization = 

  (instituteCampusId, roleId, index, degreeIds, departmentIds, search, publsihedBy) =>
    async (dispatch, getState) => {
      try {
        let stage = index === null ? '' : `&stageIndex=${index}`
        let degreeId = degreeIds?.map(item => item.value).join(',')
        let departmentId = departmentIds?.map(item => item.departId).join(',')
        let searchData = `&search=${search || ''}`
        let checkDegree = degreeId?.length ? `&degreeIds=${degreeId}` : ''
        let checkDepartment = departmentId?.length ? `&streamIds=${departmentId}` : ''
        let forInstitute =
          publsihedBy == 'INSTITUTE'
            ? `&forInstitute=true&forAts=true`
            : `&forInstitute=false`
        const result = await studentRequest.get(
          `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/filter?forSpecialisation=true${stage}${checkDegree}${checkDepartment}${searchData}${forInstitute}`
        )
        return result?.data?.data
      } catch (error) {
        ErrorMessage(error?.message)
      }
    }
export const atsExportCandidate =
  (roleId, instituteId, key, payLoad, stage) => async (dispatch, getState) => {
    try {
      const config = (key !== 'googlesheet' && key !== 'count') ? { responseType: 'blob' } : {}
      const response = await studentRequest.put(
        `/students/role/${roleId}/instituteCampus/${instituteId}/candidate/${key}/export`,
        payLoad,
        config
      )
      if (response?.data && typeof response.data === 'object') {
        response.data.headers = response.headers
      }
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }

export const statusFilterList =
  (roleId, stage) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = state?.auth?.instituteDetails?.id
    const isOffer = stage === 'offer'
    const stageUrl =
      stage !== 'all_candidates' ? `?isOffer=${isOffer}&stage=${stage}` : ''
    try {
      const response = await studentRequest.get(
        `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/statusfilter/list${stageUrl}`
      )
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }


  export const corporateFilterList =
  (roleId) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = state?.auth?.instituteDetails?.id
    try {
      const response = await corporateRequest.post(
        `/corporate/institute/${instituteCampusId}/jobs/${roleId}/corpfilter`
,{}
      )
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }

  export const studentFilterList =
  (roleId) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = state?.auth?.instituteDetails?.id
    try {
      const response = await studentRequest.get(
        `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/studentfilter`
      )
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }

  export const StudentEmailList = (roleId) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = state?.auth?.instituteDetails?.id
    let payload ={
      pageNo : 0,
      pageLimit : 5000
    }
    try {
    const response = await studentRequest.post(
                  `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/list`,
                  payload
                )
      return response?.data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }
